import { endOfDay, format, formatISO, isPast } from 'date-fns';
import { parseISODate } from '@ygtechnologies/rubus-frontend-utilities';

export function numberToClock(value: number) {
    const hours = value / 60;
    const minutes = value % 60;
    let newDate = new Date();
    newDate.setHours(hours, minutes);
    return toTimeOnly(newDate);
}

export function isDeadlineInPast(value: Date | string) {
    return isPast(endOfDay(parseISODate(value)));
}

export function toTimeOnly(date: Date | string) {
    return format(parseISODate(date), 'HH:mm');
}

export function toDateOnly(date: Date | string) {
    return formatISO(parseISODate(date), { representation: 'date' });
}
